import { getDeviceType } from '~/utils/device'

/** Fires a `user_location` GTM event when the user selects their country. */
export const trackUserLocation = (content) => {
	const params = {
		country: content.country,
	}
	LuckyWiseAnalytics.click('user_location', params)
}

/** Fires a `user_game` GTM event when the user selects a lottery. */
export const trackUserSelectedGame = (content) => {
	const params = {
		game_name: content.game_name,
		timestamp: new Date().toISOString(),
		device_type: getDeviceType(),
	}
	LuckyWiseAnalytics.click('user_game', params)
}

/** Fires a `random_play` GTM event when the user uses the random-number generator. */
export const trackRandomPlay = (content) => {
	const params = {
		country: content.country,
		game_name: content.game_name,
		random_numbers: content.random_numbers,
	}
	LuckyWiseAnalytics.click('random_play', params)
}

/** Fires a `luck_testing` GTM event when the user submits their numbers to check results. */
export const trackLuckTesting = (content) => {
	const params = {
		country: content.country,
		game_name: content.game_name,
		is_random: content.is_random,
		numbers: content.numbers,
	}
	LuckyWiseAnalytics.click('luck_testing', params)
}

/** Fires a `clear_all_clicked` GTM event when the user clears their number selection. */
export const trackClearAll = (content) => {
	const params = {
		context: content.context,
	}
	LuckyWiseAnalytics.click('clear_all_clicked', params)
}

/** Fires a `carrousel` GTM event when the user clicks a lottery card in the home carousel. */
export const trackCardCarousel = (content) => {
	const params = {
		lottery_id: content.lottery_id,
		game_name: content.lottery_name,
		prize: content.lottery_prize,
		numbers: content.lottery_numbers,
		timestamp: new Date().toISOString(),
		device_type: getDeviceType(),
	}
	LuckyWiseAnalytics.click('carrousel', params)
}
